import { createSelector, createFeatureSelector } from '@ngrx/store';
import { LayoutState } from '../_reducers/layout.reducer';

export const selectLayoutState = createFeatureSelector<LayoutState>('layout');

export const selectLayoutLoadingSpinner = createSelector(selectLayoutState, (state) => state.loadingSpinner);
